import React, { useState, useEffect, lazy, Suspense } from 'react';
import './style.scss';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';
import { getFeedsForFeedreader, getNewsByIdForFeedreader } from 'utils/api'
import FeedsList from './FeedsList.js'
import NewsList from './NewsList.js'
import NewsItem from './NewsItem.js'
import FeedsListMobile from './FeedsListMobile.js'
//import NewsListMobile from './NewsListMobile.js'
import MobileNav from './MobileNav.js'
import Loader from 'components/Loader';
const NewsListMobile = lazy(() => import('./NewsListMobile.js'));

function FeedReader(props) {
    const [feeds, setFeeds] = useState([]); //array of feeds: id, name, newsCount
    const [selectedFeed, setSelectedFeed] = useState(null); // id of selected feed
    const [news, setNews] = useState([]); //array of news from feed
    const [selectedNewsItem, setSelectedNewsItem] = useState(null); // selected item object
    const [feedsLoading, setFeedsLoading] = useState(true);
    const [newsLoading, setNewsLoading] = useState(true);
    const [isFirstTabSelected, toggleSelectedTab] = useState(true);

    useEffect(() => {
        getFeedsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getFeedsList = () => {
        getFeedsForFeedreader()
            .then((data) => {
                if(data.result && data.result.length > 0) {
                    let sortedArray = data.result.sort((a, b) => a.attachedName.localeCompare(b.attachedName));
                    setFeeds(sortedArray);
                    setSelectedFeed(sortedArray[0]);
                    setFeedsLoading(false);
                    if(data && sortedArray[0].id) {
                        getNewsByFeedId(sortedArray[0].id);
                    } else {
                        setNewsLoading(false);
                    }
                } else {
                    setFeedsLoading(false);
                    setNewsLoading(false);
                }
            })
            .catch((err) => {
                setFeedsLoading(false);
                setNewsLoading(false);
                console.log('err: ', err)
            });
    }

    const selectFeed = (feed) => {
        setSelectedFeed(feed);
        getNewsByFeedId(feed.id);
        if(window.innerWidth < 1024) {
            toggleSelectedTab(false);
        }
    }

    const selectNews = (id) => {
        setSelectedNewsItem(news.find(item => item.id === id))
    }

    const getNewsByFeedId = (id) => {
        setNewsLoading(true);
        let deviceQuery = window.innerWidth > 1024 ?'?itemsOnPage=1000&viewer=1' : '?itemsOnPage=1000&viewer=2';
        getNewsByIdForFeedreader(id, deviceQuery)
            .then((data) => {
                setNews(data.result);
                setSelectedNewsItem(data.result[0]);
                setNewsLoading(false);

            })
            .catch((err) => {
                console.log('err: ', err)
                setNewsLoading(false);
            });
    }

    return (
        <div className="w-100 d-flex">
            {window.innerWidth > 1024 ? (
                <div className="myfeeds-desktop w-100 d-flex">
                    <FeedsList 
                        feeds={feeds} 
                        selectedFeed={selectedFeed && selectedFeed} 
                        setSelectedFeed={selectFeed} 
                        feedsLoading={feedsLoading} 
                    />
                    <NewsList 
                        news={news} 
                        feedName={selectedFeed && selectedFeed.attachedName}
                        selectedNewsItem={selectedNewsItem} 
                        selectNews={selectNews} 
                        newsLoading={newsLoading} 
                    />
                    <NewsItem selectedNewsItem={selectedNewsItem} sourceType={selectedFeed && selectedFeed.type} />
                </div>
            ) : (
                <div className="w-100">
                    <div className="d-flex w-100">
                        <FeedsListMobile 
                            feeds={feeds} 
                            selectedFeed={selectedFeed && selectedFeed} 
                            setSelectedFeed={selectFeed} 
                            feedsLoading={feedsLoading} 
                            isFirstTabSelected={isFirstTabSelected}
                        />
                        <Suspense fallback={
                            <div style={{ 
                                height: 'calc(100vh - 95px - 150px)', 
                                borderTop: '1px solid rgb(49, 71, 132)' 
                            }}>
                                <div style={{padding: '10px 0 0 15px'}}>
                                    {/*<i className="fa fa-spinner fa-spin" />*/}
                                    <Loader small/>
                                </div>
                            </div>
                        }>
                            <NewsListMobile 
                                news={news} 
                                feedName={selectedFeed && selectedFeed.attachedName}
                                newsLoading={newsLoading} 
                                isFirstTabSelected={isFirstTabSelected}
                            />
                        </Suspense>
                    </div>
                    <MobileNav isFirstTabSelected={isFirstTabSelected} toggleSelectedTab={toggleSelectedTab}/>
                </div>
            )}
        </div>
    );
}

export default connect(null, { logout })(withRouter(FeedReader));